var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSunny = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFA600",
  d: "m29.697 17.672-3.209-2.83 3.096-2.954a.437.437 0 0 0-.183-.737l-4.12-1.19 1.523-3.987a.44.44 0 0 0-.07-.433.44.44 0 0 0-.413-.155l-4.235.682-.344-4.251a.443.443 0 0 0-.69-.326L17.52 3.913 15.376.22a.442.442 0 0 0-.764 0l-2.463 4.24L7.89 2.002a.443.443 0 0 0-.663.379l-.01 4.265-4.275-.352a.44.44 0 0 0-.399.187.44.44 0 0 0-.036.437l1.83 3.857L.323 12.28a.44.44 0 0 0-.124.75l3.317 2.704-2.977 3.07a.437.437 0 0 0 .211.73l4.163 1.029-1.365 4.044a.44.44 0 0 0 .088.43c.104.117.264.17.418.139l4.205-.846.51 4.235a.443.443 0 0 0 .702.299l3.435-2.558 2.288 3.49a.442.442 0 0 0 .763-.03l1.999-3.656 3.623 2.284a.443.443 0 0 0 .677-.352l.178-4.262 4.258.518a.44.44 0 0 0 .406-.172.44.44 0 0 0 .054-.435l-1.678-3.926 4.07-1.348a.44.44 0 0 0 .153-.744z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.845,
  cy: 14.923,
  fill: "#FFDB2D",
  rx: 9.086,
  ry: 9.079
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCA00",
  d: "M14.845 5.844q-.342 0-.676.025c4.702.346 8.41 4.267 8.41 9.054s-3.708 8.709-8.41 9.054q.334.025.676.025c5.018 0 9.086-4.064 9.086-9.079 0-5.014-4.068-9.079-9.086-9.079"
}))));
export default SvgSunny;